export const truncate = (str: string, maxLength = 20) =>
    str.length > maxLength ? str.slice(0, maxLength) + '...' : str;

export const stripUrlDecorations = (value: string) =>
    value.replace(/^https?:\/\//, '').replace(/\/$/, '');

export const nv = (data: string | number | null | undefined): string => data?.toString() ?? '-';
